import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Home from "@/pages/Home";
import Stories from "@/pages/Stories";
import StoryDetail from "@/pages/StoryDetail";
import Evidence from "@/pages/Evidence";
import Crew from "@/pages/Crew";
import CrewDetail from "@/pages/CrewDetail";
import BadIdeas from "@/pages/BadIdeas";
import BadIdeaDetail from "@/pages/BadIdeaDetail";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Complain from "@/pages/Complain";
import About from "@/pages/About";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const PublicRoutes = () => (
  <Layout>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/stories" element={<Stories />} />
      <Route path="/stories/:slug" element={<StoryDetail />} />
      <Route path="/evidence" element={<Evidence />} />
      <Route path="/crew" element={<Crew />} />
      <Route path="/crew/:slug" element={<CrewDetail />} />
      <Route path="/bad-ideas" element={<BadIdeas />} />
      <Route path="/bad-ideas/:slug" element={<BadIdeaDetail />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/shop/:slug" element={<ProductDetail />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/checkout/success" element={<CheckoutSuccess />} />
      <Route path="/complain" element={<Complain />} />
      <Route path="/what-the-hell" element={<About />} />
    </Routes>
  </Layout>
);

function App() {
  return (
    <div className="App">
      {/* Global SVG filter defs — referenced via CSS filter:url(#id) elsewhere */}
      <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden>
        <defs>
          {["skull", "flame", "compass"].map((k, i) => {
            const seedEdge = [7, 13, 21][i];
            const seedGrain = [3, 9, 17][i];
            return (
              <filter key={k} id={`stamp-grit-${k}`} x="-20%" y="-20%" width="140%" height="140%">
                <feTurbulence type="fractalNoise" baseFrequency="0.45" numOctaves="3" seed={seedEdge} result="edge" />
                <feDisplacementMap in="SourceGraphic" in2="edge" scale="3.2" result="warp" />
                <feTurbulence type="fractalNoise" baseFrequency="1.4" numOctaves="2" seed={seedGrain} result="grain" />
                <feColorMatrix
                  in="grain"
                  values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0 -5 3"
                  result="mask"
                />
                <feComposite in="warp" in2="mask" operator="in" />
              </filter>
            );
          })}
        </defs>
      </svg>
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/*" element={<PublicRoutes />} />
            </Routes>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
